<template>
  <div class="pager" v-bind:class="pagerClass">
    <span v-if="Pages.first < Pages.from" class="label" v-on:click="setCurrent(Pages.first)">{{Pages.first}}</span>
    <span v-if="Pages.first < Pages.from" class="dots" v-on:click="setCurrent('first-half')">...</span>
    <span
      v-for="page in Pages.pages"
      v-bind:key="page.value"
      v-on:click="setCurrent(page.value)"
      v-bind:class="{active:page.isActive}"
    >{{page.value}}</span>
    <span v-if="Pages.last > Pages.to" class="dots" v-on:click="setCurrent('last-half')">...</span>
    <span v-if="Pages.last > Pages.to" class="label" v-on:click="setCurrent(Pages.last)">{{Pages.last}}</span>
  </div>
</template>
<script>
export default {
  name: "Pagination",
  props: ["activePage", "total", "perPage"],
  data() {
    return {
      pages: [],
      last: 0,
      first: 1,
      from: 1,
      to: 1,
      current:1,
    };
  },
  computed: {
    pagerClass() {
      return {
        normal: this.to === this.last && this.from === this.first,
        middel: this.to < this.last && this.from > this.first,
        first: this.to < this.last && this.from === this.first,
        last: this.to === this.last && this.from > this.first
      };
    },
     Pages() {
      this.pages = [];
      this.last = Math.ceil(this.total / this.perPage);
      this.from = this.current - 3 < 1 ? 1 : this.current - 3;
      this.from = (this.from - 1) === this.first? this.first:this.from;
      this.to = this.current + 3 >= this.last ? this.last : this.current + 3;
      this.to = this.to + 1 === this.last ? this.last: this.to;
      for (let index = this.from; index <= this.to; index++) {
        this.pages.push({
          value: index,
          isActive: this.current === index
        });
      }
      console.log(this.last, this.from, this.to, this.current, this.first);
      return {
      pages: this.pages,
      last: this.last,
      first: this.first,
      from: this.from,
      to: this.to,
      current:this.current,
    }
    
    }
  },
  mounted() {
    this.current = this.activePage
  },
  methods: {
     setCurrent(value){
     if(!isNaN(value)){ this.current = value;}
     if(value === 'first-half') {
       this.current =this.first + Math.ceil((this.from - this.first) / 2); 
     }
     if(value === 'last-half'){
        this.current +=Math.ceil((this.last - this.to) / 2); 
     }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
.pager {
  display: grid;
  grid-gap: 7.5px;
  width: 100%;
  -ms-flex-line-pack: center;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, 21px);
}
.pager.normal {
  grid-template-columns: repeat(auto-fit, 21px);
}
.pager.first {
  grid-template-columns: repeat(auto-fit, 21px) 42px;
}
.pager.last {
  grid-template-columns: 42px repeat(auto-fit, 21px);
}
.pager.middel {
  grid-template-columns: 42px repeat(auto-fit, 21px);
}
.pager span {
  display: flex;
  width: 21px;
  height: 21px;
  border: 1px solid #fff;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition:all 0.3s linear;
  background: #2c3e50;
}
.pager span.active{
  color:#232323;
  background: #78f9ef;
  border-color: #78f9ef;
}
.pager span.label {
  width: 42px;
}
.pager span.dots {
  border: none;
  cursor: inherit;
}
</style>
